import { __styles } from '@griffel/react';
export const useBundledIconStyles = __styles({
  root: {
    mc9l5x: "fjseox"
  },
  visible: {
    mc9l5x: "f1w7gpdv"
  }
}, {
  d: [".fjseox{display:none;}", ".f1w7gpdv{display:inline;}"]
});